import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", { d: "M-3-3h24v24H-3z" }),
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M10.5 1A1.5 1.5 0 0 1 12 2.5v10a1.5 1.5 0 0 1-3 0v-10A1.5 1.5 0 0 1 10.5 1m-5 5A1.5 1.5 0 0 1 7 7.5v5a1.5 1.5 0 0 1-3 0v-5A1.5 1.5 0 0 1 5.5 6M2 16h15a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0zm13.5-8A1.5 1.5 0 0 1 17 9.5v3a1.5 1.5 0 0 1-3 0v-3A1.5 1.5 0 0 1 15.5 8"
      })
    ], -1)
  ]))]))
}
export default { render: render }